import SpravaoUcastiVerejnostiEditPage from './SpravaoUcastiVerejnostiEditPage';

export default SpravaoUcastiVerejnostiEditPage;
